// extracted by mini-css-extract-plugin
export var categoryIcon = "_d2-5";
export var connectorContainer = "_d2-1";
export var connectorLine = "_d2-0";
export var minHeight0 = "_d2-6";
export var relativeUnitValueSelector = "_d2-2";
export var trifoldSelectorBody = "_d2-4";
export var trifoldSelectorList = "_d2-3";